/* eslint-disable */
import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Backdrop,
  Box,
  Typography,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Phone from '../../../assets/Images/HoldingMobile.png';

/* ─────────────────────────────────────────────────
   ReactivateModal
───────────────────────────────────────────────── */
export function ReactivateModal({
  open,
  reactivateState,
  setReactivateState,
  reactivateLoading,
  onReactivate,
  onKeepWaiting,
}) {
  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: {
          borderRadius: '24px',
          padding: '35px 20px 30px 20px',
          width: '420px',
          maxWidth: '90vw',
          textAlign: 'center',
          boxShadow: '0 18px 45px rgba(15, 23, 42, 0.18)',
        },
      }}
    >
      <DialogContent sx={{ textAlign: 'center', padding: 0 }}>
        <img src={Phone} alt="phone" style={{ width: 120, margin: '0 auto 16px', display: 'block' }} />
        <h2 style={{ margin: '0 0 8px', fontSize: 22, fontWeight: 700 }}>
          Reactivate Your Account?
        </h2>
        <p style={{ margin: 0, fontSize: 14, color: '#6b6b6b', lineHeight: 1.5 }}>
          This account is scheduled for deletion.
          <br />
          To regain access, click or tap on &quot;Yes, Reactivate&quot;
        </p>
        <p style={{ marginTop: 20, fontSize: 14, color: '#6b6b6b', lineHeight: 1.5 }}>
          If you still want deletion, you can wait and your
          <br />
          account will be removed after the grace period.
        </p>

        <Button
          fullWidth
          disabled={reactivateLoading}
          sx={{
            width: '85%',
            background: reactivateState === 'hover' ? 'green' : '#52c28c',
            color: '#fff',
            borderRadius: '30px',
            mt: 3,
            '&:hover': { background: 'green', color: '#fff' },
          }}
          onMouseEnter={() => reactivateState === 'default' && setReactivateState('hover')}
          onMouseLeave={() => reactivateState === 'hover' && setReactivateState('default')}
          onClick={onReactivate}
        >
          {reactivateState === 'reactivating' ? 'Reactivating...' : 'Yes, Reactivate'}
        </Button>

        <Button
          fullWidth
          sx={{
            width: '85%',
            background:
              reactivateState === 'waiting' || reactivateState === 'default' ? '#e8e8e8' : 'red',
            color: reactivateState === 'hoverNo' ? '#fff' : '#000',
            borderRadius: '30px',
            mt: 2,
            '&:hover': {
              background: reactivateState === 'waiting' ? '#e8e8e8' : 'red',
              color: reactivateState === 'waiting' ? '#000' : '#fff',
              cursor: reactivateState === 'waiting' ? 'not-allowed' : 'pointer',
            },
          }}
          onMouseEnter={() => reactivateState === 'default' && setReactivateState('hoverNo')}
          onMouseLeave={() => reactivateState === 'hoverNo' && setReactivateState('default')}
          onClick={onKeepWaiting}
        >
          {reactivateState === 'waiting' ? 'Back to waiting…' : 'No, Wait for Deletion'}
        </Button>
      </DialogContent>
    </Dialog>
  );
}

/* ─────────────────────────────────────────────────
   LoadingOverlay
───────────────────────────────────────────────── */
export function LoadingOverlay({ open }) {
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        backdropFilter: 'blur(8px)',
      }}
      open={open}
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        sx={{
          backgroundColor: 'white',
          padding: { xs: '60px 50px', md: '100px 120px' },
          borderRadius: '24px',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
          minWidth: { xs: '380px', md: '600px' },
          maxWidth: '90vw',
          textAlign: 'center',
        }}
      >
        <Typography
          variant="h5"
          sx={{
            color: '#1a1a1a',
            fontWeight: 700,
            marginBottom: '12px',
            fontSize: { xs: '26px', md: '32px' },
            lineHeight: 1.3,
            letterSpacing: '-0.5px',
            mt: 4,
          }}
        >
          Setting up your dashboard
        </Typography>
        <Typography
          variant="body1"
          sx={{ color: '#666', fontSize: { xs: '16px', md: '18px' }, lineHeight: 1.6, maxWidth: '450px' }}
        >
          Please wait while we prepare your personalized learning experience
        </Typography>
        <Box sx={{ margin: '24px', display: 'flex', gap: '8px', alignItems: 'center' }}>
          {[0, 0.2, 0.4].map((delay, i) => (
            <Box
              key={i}
              sx={{
                width: '20px',
                height: '20px',
                borderRadius: '50%',
                padding: '30px',
                backgroundColor: '#52c28c',
                animation: 'pulse 1.5s ease-in-out infinite',
                animationDelay: `${delay}s`,
                '@keyframes pulse': {
                  '0%, 100%': { opacity: 0.3, transform: 'scale(0.8)' },
                  '50%': { opacity: 1, transform: 'scale(1.2)' },
                },
              }}
            />
          ))}
        </Box>
      </Box>
    </Backdrop>
  );
}

/* ─────────────────────────────────────────────────
   PasswordChangedModal
───────────────────────────────────────────────── */
export function PasswordChangedModal({ open, changePasswordLoading, onClose }) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ textAlign: 'center' }}>Password Changed!</DialogTitle>
      <DialogContent>
        <p>You have successfully changed your password.</p>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', width: '100%' }}>
        <LoadingButton
          size="medium"
          type="button"
          variant="contained"
          loading={changePasswordLoading}
          sx={{ backgroundColor: '#345CA1', borderRadius: '5px' }}
          onClick={onClose}
        >
          Go back To Login
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}